import Vue from 'vue'
import Router from 'vue-router'
// import { component } from 'vue/types/umd'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err && err.name === 'NavigationDuplicated') {
      return this.currentRoute
    }
    throw err
  })
}

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/main-page',
      component: () => import('@/views/dashboard/Index'),
      // component: () => import('@/views/dashboard/tables/setting'),
      children: [
        // {
        //   name: 'login',
        //   path: 'tables/login',
        //   component: () => import('@/views/dashboard/tables/login'),
        //   meta: {
        //     noDrawer: true,
        //   }
        // },
        {
          path: 'op',
          redirect: 'op/tables/op',
          component: () => import('@/views/dashboard/tables/index'),
          children: [
            {
              path: '/main-page',
              component: () => import('@/views/dashboard/tables/mainPage'),
              meta: {
                noDrawer: true,
                noFooter: true,
                title: 'Main Page'
              }
            },
            {
              name: 'NIQ',
              path: 'tables/op',
              component: r => require.ensure([], () => r(require('@/views/dashboard/tables/op')), 'table-op'),
              meta: {
                module: 'op',
                planningBackToMain: true,
                db: 'international'
              }
            },
            // {
            //   name: 'GFK',
            //   path: 'tables/ci-op',
            //   component: r => require.ensure([], () => r(require('@/views/dashboard/tables/op')), 'table-ci-op'),
            //   meta: {
            //     module: 'op',
            //     db: 'ci',
            //   }
            // },
            // {
            //   name: 'OP24 For Bases',
            //   path: 'tables/bases-op',
            //   component: r => require.ensure([], () => r(require('@/views/dashboard/tables/op')), 'table-bases-op'),
            //   meta: {
            //     module: 'op',
            //     db: 'bases',
            //   }
            // },
            // 3 Years Plan
            // {
            //   name: '3 Years Plan',
            //   path: 'tables/op',
            //   component: r => require.ensure([], () => r(require('@/views/dashboard/tables/op_v1')), 'table-op_v1'),
            //   meta: {
            //     module: 'op_v1'
            //   }
            // },
            {
              name: 'View Data',
              path: 'tables/viewdata',
              component: r => require.ensure([], () => r(require('@/views/dashboard/tables/op')), 'table-viewdata'),
              // component: () => import('@/views/dashboard/tables/Forecasting'),
              meta: {
                module: 'viewdata',
                planningBackToMain: true,
                db: 'international'
              }
            },
            // {
            //   name: 'View Data For GFK',
            //   path: 'tables/ci-viewdata',
            //   component: r => require.ensure([], () => r(require('@/views/dashboard/tables/op')), 'table-ci-viewdata'),
            //   // component: () => import('@/views/dashboard/tables/Forecasting'),
            //   meta: {
            //     module: 'viewdata',
            //     db: 'ci',
            //   },
            // },
            // {
            //   name: 'View Data For Bases',
            //   path: 'tables/bases-viewdata',
            //   component: r => require.ensure([], () => r(require('@/views/dashboard/tables/op')), 'table-bases-viewdata'),
            //   // component: () => import('@/views/dashboard/tables/Forecasting'),
            //   meta: {
            //     module: 'viewdata',
            //     db: 'bases',
            //   },
            // },
            {
              name: 'Setting For NIQ',
              path: 'tables/setting',
              component: r => require.ensure([], () => r(require('@/views/dashboard/tables/setting')), 'table-setting'),
              meta: {
                module: 'setting',
                db: 'international'
              }
            },
            // },
            {
              name: 'Maintenance',
              path: 'tables/maintenance',
              component: r => require.ensure([], () => r(require('@/views/dashboard/tables/maintenance')), 'table-maintenance'),
              meta: {
                module: 'maintenance',
                db: 'international'
              }
            },
            {
              name: 'AIM',
              path: 'tables/aim',
              component: r => require.ensure([], () => r(require('@/views/dashboard/tables/aim')), 'table-aim'),
              meta: {
                module: 'aim',
                db: 'international'
              }
            },
            // {
            //   name: 'Setting For 3YP',
            //   path: 'tables/ci-setting',
            //   component: r => require.ensure([], () => r(require('@/views/dashboard/tables/setting')), 'table-ci-setting'),
            //   meta: {
            //     module: 'setting',
            //     db: 'ci',
            //   }
            // },
            // {
            //   name: 'Setting For Bases',
            //   path: 'tables/bases-setting',
            //   component: r => require.ensure([], () => r(require('@/views/dashboard/tables/setting')), 'table-bases-setting'),
            //   meta: {
            //     module: 'setting',
            //     db: 'bases',
            //   }
            // },
            {
              name: 'Access Control',
              path: 'access/role',
              component: r => require.ensure([], () => r(require('@/views/dashboard/custom/access/country_access/index')), 'table-index'),
              meta: {
                module: 'role',
                db: 'international'
              }
            },
            // {
            //   name: 'Access Control For GFK',
            //   path: 'access/ci-role',
            //   component: r => require.ensure([], () => r(require('@/views/dashboard/custom/access/country_access/index')), 'table-ci-index'),
            //   meta: {
            //     module: 'role',
            //     db: 'ci',
            //   }
            // },
            // {
            //   name: 'Access Control For Bases',
            //   path: 'access/bases-role',
            //   component: r => require.ensure([], () => r(require('@/views/dashboard/custom/access/country_access/index')), 'table-bases-index'),
            //   meta: {
            //     module: 'role',
            //     db: 'bases',
            //   }
            // },
            {
              name: 'login',
              path: 'tables/login',
              component: () => import('@/views/dashboard/tables/login'),
              meta: {
                noDrawer: true
              }
            },
            {
              name: 'notice',
              path: 'tables/notice',
              component: () => import('@/views/dashboard/tables/notice'),
              meta: {
                noDrawer: true,
                noAppBar: true
              }
            },
            // {
            //   name: 'summary',
            //   path: 'tables/summary',
            //   component: () => import('@/views/dashboard/tables/summary')
            // },
            {
              name: 'client_details',
              path: 'tables/client-details',
              component: () => import('@/views/dashboard/tables/client-details')
            },
            // {
            //   name: 'history',
            //   path: 'tables/history',
            //   component: () => import('@/views/dashboard/tables/history')
            // },
            {
              name: 'download-center',
              path: 'tables/download-center',
              component: () => import('@/views/dashboard/tables/download-center')
            },
            // {
            //   path: 'pages/UserProfile',
            //   component: () => import('@/views/dashboard/pages/UserProfile'),
            // },
            {
              name: 'blackboxupload',
              path: 'tables/blackboxupload',
              component: () => import('@/views/dashboard/tables/blackboxupload'),
              meta: {
                noDrawer: true,
                title: 'BlackBox'
              }
            },
            // 2025-09-25: Rename OP Walk module route to Supplemental Tracker
            {
              // 2025-09-25: Update Supplemental Tracker route name
              name: 'Supplemental Tracker',
              // 2025-09-25: Update Supplemental Tracker route path
              path: 'tables/supplemental-tracker',
              // 2025-09-25: Load Supplemental Tracker component
              component: () => import('@/views/dashboard/tables/supplementalTracker'),
              meta: {
                noDrawer: true,
                // 2025-09-25: Update Supplemental Tracker page title
                title: 'Supplemental Tracker',
                datasetType: 'revenue'
              }
            },
            {
              name: 'Supplemental Expense',
              path: 'tables/supplemental-expense',
              component: () => import('@/views/dashboard/tables/supplementalTracker'),
              meta: {
                noDrawer: true,
                title: 'Supplemental Expense',
                datasetType: 'expense'
              }
            },
            {
              name: 'Mass Upload For NIQ',
              path: 'tables/massupload',
              // component: () => import('@/views/dashboard/tables/massupload'),
              component: r => require.ensure([], () => r(require('@/views/dashboard/tables/massupload')), 'table-massupload'),
              meta: {
                noDrawer: true,
                title: 'MassUpload',
                db: 'international'
              }
            },
            // {
            //   name: 'Mass Upload For GFK',
            //   path: 'tables/ci-massupload',
            //   // component: () => import('@/views/dashboard/tables/massupload'),
            //   component: r => require.ensure([], () => r(require('@/views/dashboard/tables/massupload')), 'table-ci-massupload'),
            //   meta: {
            //     noDrawer: true,
            //     title: 'MassUpload',
            //     db: 'ci',
            //   }
            // },
            {
              name: 'BLACKBOXUPLOAD ACCESS',
              path: 'tables/blackboxuploadAccess',
              component: () => import('@/views/dashboard/tables/blackboxuploadAccess'),
              meta: {
                noDrawer: true
              }
            },
            // 2025-09-25: Add Supplemental Tracker access route
            {
              // 2025-09-25: Rename access route display name
              name: 'Supplemental Tracker Access',
              // 2025-09-25: Update tracker access route path
              path: 'tables/tracker-access',
              // 2025-09-25: Load tracker access component
              component: () => import('@/views/dashboard/tables/trackerAccess'),
              meta: {
                noDrawer: true
              }
            },
            {
              name: 'MASS UPLOAD ACCESS',
              path: 'tables/massuploadAccess',
              // component: () => import('@/views/dashboard/tables/massuploadAccess'),
              component: r => require.ensure([], () => r(require('@/views/dashboard/tables/massuploadAccess')), 'table-massuploadAccess'),
              meta: {
                noDrawer: true,
                db: 'international'
              }
            }
            // {
            //   name: 'MASS UPLOAD ACCESS_CI',
            //   path: 'tables/ci-massuploadAccess',
            //   // component: () => import('@/views/dashboard/tables/massuploadAccess'),
            //   component: r => require.ensure([], () => r(require('@/views/dashboard/tables/massuploadAccess')), 'table-ci-massuploadAccess'),
            //   meta: {
            //     noDrawer: true,
            //     db: 'ci',
            //   }
            // },
          ]
        }
      ]
    }
  ]
})
